import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useParams } from "react-router";

import * as Api from "@/api";
import { clearPbxData } from "@/store/reducers/root";
import Valkyrie, { viSpinnerThird } from "@sippy-platform/valkyrie";

import { Stack, Typography } from "@mui/material";

export default function PbxContainer() {
  const dispatch = useDispatch();
  const { pbxId } = useParams();

  const account = useSelector((state) => state.auth);
  const pbx = useSelector((state) => state.domain.pbx);

  useEffect(() => {
    if (pbxId && ((pbxId && !pbx?.context) || pbxId !== pbx?.context)) {
      Promise.resolve(Api.getPbxByContext(pbxId, true, true)).then(() => {
        Promise.all(
          account.accessLevel === 4
            ? [Api.getUsers()]
            : [
                Api.getCallParkings(),
                Api.getConferences(),
                Api.getDayNights(),
                Api.getDestinations(),
                Api.getDevices(true),
                Api.getGroups(),
                Api.getIntercoms(),
                Api.getIvrs(),
                Api.getMobileUsers(),
                Api.getPossibleQueueMembers(),
                Api.getQueues(),
                Api.getSounds(),
                Api.getTimetables(),
                Api.getUsers(),
                Api.getVoicemails(),
              ],
        );
      });
    }
  }, [account.accessLevel, pbx?.context, pbxId]);

  useEffect(() => {
    return () => {
      dispatch(clearPbxData());
    };
  }, [dispatch]);

  if (!pbx.context && pbx.context !== pbxId) {
    return (
      <Stack
        sx={{
          textAlign: "center",
          px: 1,
          pt: 24,
        }}
      >
        <Typography variant="h1" color="primary">
          <Valkyrie icon={viSpinnerThird} spin />
        </Typography>
        <Typography variant="h5">Getting your PBX ready...</Typography>
      </Stack>
    );
  }

  return <Outlet />;
}
